import React, { useState } from 'react';
import { Link } from 'react-router';

import Button from '~/components/Button';
import Login from '~/components/Login';
import Modal from '~/components/Modal';
import { useAuth } from '~/contexts/AuthContext';

interface GameModeModalProps {
  dataCy: string;
  title: string;
  modeLabel: string;
  ctaTo: string;
  onClose: () => void;
  children: React.ReactNode;
}

function GameModeModal({
  dataCy,
  title,
  modeLabel,
  ctaTo,
  onClose,
  children
}: GameModeModalProps) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  return (
    <div className="p-base relative flex flex-col gap-6" data-cy={dataCy}>
      <h1 className="h-3xl font-bold uppercase tracking-wider">{title}</h1>

      {children}

      <div>
        {!isAuthenticated && (
          <div className="flex justify-between gap-4 bg-gray-300 py-4 pl-5 pr-2 rounded-2xl backdrop-blur-2xl">
            <p>
              <button
                className="p-base cursor-pointer text-start"
                type="button"
                onClick={() => setIsLoginModalOpen(true)}
              >
                <span>You need to </span>
                <span className="underline underline-offset-3">sign in</span>
                <span> to play {modeLabel}.</span>
              </button>
            </p>
            <Button variant="green" disabled>
              Let's Go
            </Button>
            <Modal
              isOpen={isLoginModalOpen}
              onClose={() => setIsLoginModalOpen(false)}
              size="small"
              disabled={isAuthenticated}
            >
              <Login />
            </Modal>
          </div>
        )}
      </div>

      <div className="flex w-full items-end justify-between gap-4">
        <Button
          data-cy="back-modal"
          variant="purple"
          size="small"
          className="h-fit"
          onClick={onClose}
        >
          Back
        </Button>

        {isAuthenticated && (
          <Button as={Link} to={ctaTo} variant="green">
            Create
          </Button>
        )}
      </div>
    </div>
  );
}

export default GameModeModal;
